import React from 'react'
import { FieldLabel } from '../form/index'
import ProductSearchSelect from './ProductSearchSelect'

const ProductSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={ProductSearchSelect} />
)

export default ProductSearchSelectField
